import { render, staticRenderFns } from "./field-setup.vue?vue&type=template&id=c1287c80&scoped=true&"
import script from "./field-setup.vue?vue&type=script&lang=js&"
export * from "./field-setup.vue?vue&type=script&lang=js&"
import style0 from "./field-setup.vue?vue&type=style&index=0&id=c1287c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1287c80",
  null
  
)

export default component.exports